import React, { memo, useCallback, useEffect, useState } from 'react';
import { useQuotaTariffs } from 'reactApp/components/BuyForSafe/useQuotaTariffs';
import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';
import type { Product } from 'reactApp/types/Billing';
import { Dialog } from 'reactApp/ui/Dialog/Dialog';
import { ETabsName } from 'reactApp/ui/TariffSectionNew/TariffSection.constants';
import { TariffsModalContent } from 'reactApp/ui/TariffsModal/TariffsModalContent';
import { noopVoid } from 'reactApp/utils/helpers';

interface Props {
    onBuyClick: (product: Product) => void;

    onClose?(): void;

    onShow?(): void;
}

export const BuyForSafe = memo(({ onClose = noopVoid, onShow = noopVoid, onBuyClick }: Props) => {
    const [tabActive, setTabActive] = useState<ETabsName>(ETabsName.year);
    const { tariffs, tariffIds } = useQuotaTariffs();

    useEffect(onShow, []);

    const handleClick = useCallback(
        (product: Product) => {
            onBuyClick(product);
            onClose();
        },
        [onBuyClick, onClose]
    );

    const content = (
        <TariffsModalContent
            tariffs={tariffs}
            yearTariffsCount={tariffIds.year.length}
            monthTariffsCount={tariffIds.month.length}
            activeTab={tabActive}
            setActiveTab={setTabActive}
            onBuyClick={handleClick}
            title="Больше возможностей с подпиской Mail Space"
        />
    );

    return (
        <Dialog id="buy-for-safe" open mod="frame" closeOnDimmerClick={false} onCancel={onClose}>
            {content}
        </Dialog>
    );
});

export const openBuyForSafe = ({ ...data }: Props) =>
    openPopupHelper({
        popupName: popupNames.BUY_FOR_SAFE,
        data,
    });

BuyForSafe.displayName = 'BuyForSafe';
